import api from '../api';
import { ContractDepartment } from '../../types/compliance';

// NOTE: axios baseURL already ends in `/api/v1`; paths here are relative.
const BASE = '/compliance/contract-departments';

export const contractDepartmentsService = {
  async list(): Promise<ContractDepartment[]> {
    const { data } = await api.get<ContractDepartment[]>(BASE);
    return data;
  },
};

export default contractDepartmentsService;
